export default __webpack_public_path__ + "static/media/user.d310f89e.svg";